import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Link } from '@qualtrics/ui-react';
import styles from './Banner.module.scss';

const Banner = ({ type }) => {
    return (
        <div
            className={classNames(styles.banner, {
                [styles[type]]: type,
            })}
        >
            You are viewing the docs for version 1.x.{' '}
            <Link href="/">View version 2.x docs</Link>.
        </div>
    );
};

Banner.propTypes = {
    type: PropTypes.string,
};

Banner.defaultProps = {
    type: undefined,
};

export default Banner;
